import { useParams } from 'react-router-dom'

// Components
import { Link } from '@tracklib/kit'

// Hooks
import { useArtists } from 'modules/entities/hooks'

// Types
import { Artist } from 'types'

import styles from './artists.css'

const getArtistTypeOrder = (artistType: string) => {
  if (artistType === 'Main Artist') {
    return 1
  }
  if (artistType === 'Featured artist') {
    return 2
  }
  return 0
}

export const getDisplayArtists = (artists: Array<Artist>, genres: Array<number>, artistToIncludeSlug?: string): Array<Artist> => {
  const isClassical = genres.some(x => x === 3)

  return artists
    .sort((artistA, artistB) => {
      if (artistToIncludeSlug) {
        if (artistA.slug === artistToIncludeSlug) {
          return -1
        }
        if (artistB.slug === artistToIncludeSlug) {
          return 1
        }
      }
      if (isClassical) {
        if (artistA.type === 'Composer') {
          return -1
        }
        if (artistB.type === 'Composer') {
          return 1
        }
      }

      if (!getArtistTypeOrder(artistA.type)) {
        return 1
      }

      if (!getArtistTypeOrder(artistB.type)) {
        return -1
      }

      return getArtistTypeOrder(artistA.type) - getArtistTypeOrder(artistB.type)
    })
    .reduce((agg: Array<Artist>, x) => (agg.some((art: Artist) => art.slug === x.slug) ? agg : [...agg, x]), [])
    .splice(0, 5)
}

export const ArtistsAsString = (artists: Array<Artist>, genres: Array<number>): string =>
  getDisplayArtists(artists, genres)
    .map(artist => artist.name)
    .join(', ')

const renderLink = (artist: Artist, strippedMode?: boolean) => {
  if (strippedMode) {
    return artist.name
  }
  if (artist.slug) {
    return <Link to={`/artist/${artist.slug}/`}>{artist.name}</Link>
  }
  return (
    <Link to="/tracks" query={{ q: artist.name }}>
      {artist.name}
    </Link>
  )
}

type Props = {
  artists: Array<number>
  genres: Array<number>
  strippedMode?: boolean
}

const Artists = ({ artists, genres, strippedMode }: Props) => {
  const allArtists = useArtists()
  const artistsList = artists && artists.map(artistId => allArtists[String(artistId)])

  const { slug } = useParams() as { slug: string }
  return (
    <span className={styles.container} datatesting="songitem_artistlink">
      {getDisplayArtists(artistsList, genres, slug || '').map(artist => (
        <span key={artist.id} title={artist.name}>
          {renderLink(artist, strippedMode)}
          <span>, </span>
        </span>
      ))}
    </span>
  )
}

export default Artists
